import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Input } from '@angular/core';

@Component({
  selector: 'app-speedometer',
  templateUrl: './speedometer.component.html',
  styleUrls: ['./speedometer.component.css']
})
export class SpeedometerComponent implements OnInit, AfterViewInit {
@ViewChild('speedCanvas') canvasRef: ElementRef;
  @ViewChild('canvasContainer') canvasContainerRef: ElementRef;
  width: number;
  height: number;

  @Input()
  min: number;

  @Input()
  max: number;

  @Input()
  value: number;

  percentage: number;
  valueText: string;

  startAngle: number;
  endAngle: number;

  speedometerRange: number;


  constructor() {
    this.startAngle = 0.7 * Math.PI;
    this.speedometerRange = 1.6 * Math.PI;
   }

  ngOnInit() {
    this.width = this.canvasRef.nativeElement.offsetWidth;
    this.height = this.canvasRef.nativeElement.offsetHeight;
    // this.canvasRef.nativeElement.offsetHeight = this.height;
    // this.value = 123;
    this.percentage = this.value / (this.max - this.min);
    if (this.percentage < 0.15) {
      this.valueText = 'Very Poor';
    } else if (this.percentage >= 0.15 && this.percentage < 0.3) {
      this.valueText = 'Poor';
    } else if (this.percentage >= 0.3 && this.percentage < 0.5) {
      this.valueText = 'Not Bad';
    } else if (this.percentage >= 0.5 && this.percentage < 0.65) {
      this.valueText = 'Good';
    } else if (this.percentage >= 0.65 && this.percentage < 0.8) {
      this.valueText = 'Very Good';
    } else if (this.percentage >= 0.8) {
      this.valueText = 'Excellent';
    }
    // this.valueText = "Excellent";

  }
  ngAfterViewInit(): void {
    const ctx: CanvasRenderingContext2D = this.canvasRef.nativeElement.getContext('2d');
    const containerHeight = this.canvasContainerRef.nativeElement.offsetHeight;
    ctx.canvas.width = this.width;
    ctx.canvas.height = containerHeight;
    this.height = this.canvasRef.nativeElement.offsetHeight;
    ctx.beginPath();
    const centerX = this.width / 2.0;
    const centerY = this.height / 2.0;
    const radiusWidth = 0.4 * this.width;
    const radiusHeight = 0.4 * this.height;
    // const radius = Math.min(radiusWidth, radiusHeight);
    const radius = radiusWidth;
    ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
    ctx.fillStyle = "#DFDFDF";
    ctx.fill();
    ctx.beginPath();
    const smallerRadius = 0.8 * radius;
    ctx.arc(centerX, centerY, smallerRadius, this.startAngle, 1.5 * Math.PI, false);
    // let my_gradient = ctx.createLinearGradient(0, this.width/2 - radius, 0, this.width/2 + radius);
    let my_gradient = ctx.createLinearGradient(0, this.height / 2 + smallerRadius, 0, this.height / 2 - smallerRadius);
    my_gradient.addColorStop(0, "#E40B18");
    my_gradient.addColorStop(1, "#FCC72E");
    ctx.lineWidth = 0.05 * this.width;
    ctx.strokeStyle = my_gradient;
    ctx.lineCap = 'round';
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(centerX, centerY, smallerRadius, 1.5 * Math.PI, 0.3 * Math.PI, false);
    my_gradient = ctx.createLinearGradient(0, this.height / 2 - smallerRadius, 0, this.height / 2 + smallerRadius);
    my_gradient.addColorStop(0, "#FCC72E");
    my_gradient.addColorStop(0.2, "#add035");
    my_gradient.addColorStop(1, "#85D539");
    ctx.lineWidth = 0.05 * this.width;
    ctx.strokeStyle = my_gradient;
    ctx.lineCap = 'round';
    ctx.stroke();
    // ctx.arc(centerX, centerY, smallerRadius - 0.019 * this.width, this.startAngle, 0.3 * Math.PI, true);
    // ctx.lineWidth = 0.5;
    // ctx.strokeStyle = "#DFDFDF";
    // ctx.shadowColor = 'black';
    // ctx.shadowBlur = 5;
    // ctx.stroke();
    ctx.fillStyle = "black";
    ctx.font = "20px Helvetica";
    ctx.textAlign = "center";
    ctx.fillText(this.valueText, centerX, centerY + 0.7 * smallerRadius);
    this.drawNeedle(ctx, centerX, centerY, 0.02 * this.width, 0.5 * smallerRadius);
    // this.example();
  }

  drawNeedle(ctx, startX, startY, size, length) {
    const needleAngle = this.percentage * this.speedometerRange;
    console.log(needleAngle);
    const needleAngleOffset = needleAngle + this.startAngle;
    console.log(this.speedometerRange * 180 / Math.PI);
    console.log((this.speedometerRange + this.startAngle) * 180 / Math.PI);
    console.log(this.startAngle * 180 / Math.PI);
    console.log(needleAngleOffset * 180 / Math.PI);
    ctx.beginPath();
    const arcStartAngle = needleAngleOffset - Math.PI / 2;
    const arcEndAngle = needleAngleOffset + Math.PI / 2;
    ctx.arc(startX, startY, size, arcStartAngle, arcEndAngle, true);
    ctx.moveTo(startX + size * Math.cos(arcStartAngle), startY + size * Math.sin(arcStartAngle));
    ctx.lineTo(startX + length * Math.cos(needleAngleOffset), startY + length * Math.sin(needleAngleOffset));
    ctx.lineTo(startX + size * Math.cos(arcEndAngle), startY + size * Math.sin(arcEndAngle));
    // ctx.moveTo(startX + size, startY);
    // ctx.lineTo(startX, startY + length);
    // ctx.lineTo(startX - size, startY);
    ctx.lineWidth = 1;
    ctx.fillStyle = "#464655";
    ctx.fill();
    ctx.closePath();
  }

  example() {
    const ctx: CanvasRenderingContext2D = this.canvasRef.nativeElement.getContext('2d');
    ctx.rect(0, 0, this.width, this.height);
    const my_gradient = ctx.createLinearGradient(0, 0, this.width, this.height);
    my_gradient.addColorStop(0, "#E40B18");
    my_gradient.addColorStop(1, "#FCC72E");
    ctx.fillStyle = my_gradient;
    ctx.fill();

  }

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/speedometer/speedometer.component.ts